// App configuration based on mode.
//
// One codebase serves two sites. `encore` (the default) builds enc.report;
// `pgp` builds pgp.report. Run the other one locally with
// `REACT_APP_MODE=pgp npm start`, and note that CI builds BOTH on every PR --
// a change gated behind a flag here can compile in one mode and break the
// other. See CONTRIBUTING.md.
const APP_MODE = process.env.REACT_APP_MODE || 'encore';

const configs = {
  encore: {
    appName: 'Encore',
    pageTitle: 'Encore - Music Analytics',
    showUnsignedPage: true,
    showScheduler: true,
    showSnoop: true,
    showDeals: true,
    showLuminate: true,
    // PGP publishing suite (Agenda / Charts / Roster / Mapping / Genius) lives
    // on the PGP build only.
    showPgpSuite: false,
    // Operations suite (Catalog / Commitments / Process / Updates).
    showOperations: true,
    defaultGroup: 'Encore',
    navItems: [],
    logo: 'encore1.png',
    favicon: 'encore-favicon.png'
  },
  pgp: {
    appName: 'PGP',
    pageTitle: 'PGP - Music Analytics',
    showUnsignedPage: false,
    showScheduler: false,
    showSnoop: false,
    showDeals: false,
    showLuminate: false,
    showPgpSuite: true,
    showOperations: true,
    defaultGroup: null,
    isPgp: true,
    navItems: [],
    logo: 'pgp.jpg',
    favicon: 'pgp-favicon.png'
  }
};

export const appConfig = configs[APP_MODE] || configs.encore;
export const APP_MODE_VALUE = APP_MODE;